import React from "react";
import { useQuery } from "@tanstack/react-query";
import { FaWallet, FaExchangeAlt, FaHistory, FaPlusCircle } from "react-icons/fa";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import ErrorResponse from "../../components/ErrorResponse";
import PageTitle from "../../components/PageTitle";
import is_money from "../../helpers/is_money";
import "./WalletTransaction.css";

const WalletTransaction = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["myWalletDataset"],
    queryFn: async () => {
      const req = await axiosget(`ms_student_wallet_transactions`);
      return req?.data;
    },
    staleTime: 1000 * 60 * 5, // Cache for 5 minutes
  });

  const formatDate = (dateString) => {
    // Implement your date formatting logic here
    return new Date(dateString).toLocaleDateString();
  };

  const getStatusBadge = (status) => {
    const statusClasses = {
      completed: "success",
      pending: "warning",
      failed: "danger",
    };
    return <span className={`status-badge ${statusClasses[status] || "secondary"}`}>{status}</span>;
  };

  return (
    <div className="wallet-container">
      <PageTitle title="My Wallet" sub="Save up funds to make future payments without worry" icon={<FaWallet />} />

      {isLoading && <Loader />}
      {error && <ErrorResponse type="danger" message={`Error: ${error.message}`} />}
      {data?.type !== undefined && <ErrorResponse type="danger" message={data?.message} />}

      {/* Wallet Balance Card */}
      <div className="wallet-balance-card">
        <div className="balance-content">
          <FaWallet className="wallet-icon" />
          <div>
            <h3>Available Balance</h3>
            <h1 className="balance-amount">{is_money(data?.wallet?.amount)}</h1>
          </div>
        </div>
        <button className="add-funds-btn">
          <FaPlusCircle className="btn-icon" />
          Add Funds
        </button>
      </div>

      {data?.type === undefined && data?.wallet <= 0 ? (
        <ErrorResponse type="info" title="Wallet is Empty" message="There are no funds in your wallet at the moment" />
      ) : (
        <div className="transaction-section">
          <div className="section-header">
            <FaHistory className="section-icon" />
            <h2>Transaction History</h2>
          </div>

          <div className="transactions-table">
            <div className="table-header">
              <div>#</div>
              <div>Transaction Code</div>
              <div>Amount</div>
              <div>Status</div>
              <div>Type</div>
              <div>Date</div>
            </div>

            {data?.find?.map((transaction, index) => (
              <div key={transaction.trx} className="table-row">
                <div>{index + 1}</div>
                <div className="trx-code">{transaction.trx}</div>
                <div className={`amount ${transaction.trxtype ? "credit" : "debit"}`}>{is_money(transaction.amount)}</div>
                <div>{getStatusBadge(transaction.status)}</div>
                <div>
                  <span className={`type-badge ${transaction.trxtype ? "deposit" : "withdrawal"}`}>
                    <FaExchangeAlt className="type-icon" />
                    {transaction.trxtype ? "Deposit" : "Withdrawal"}
                  </span>
                </div>
                <div className="date">{formatDate(transaction.updatedAt)}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletTransaction;
